import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold, TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';
import { Condition, Iteration } from 'Component/others';

import ButtonChangeRuleset from 'View/schedule-generate/component/button-change-ruleset';

import styles from './styles.module.css';

const RulesetDetail = ({ rulesetDetail }) => {
  const { t } = useTranslation('schedule-generate');
  const formatTimeRange = (start, end) => `${start?.slice(0, 5)} - ${end?.slice(0, 5)}`;

  return (
    <Box className={styles['ruleset__container']}>
      <Box className={styles['ruleset__section--left']}>
        <Flex gap="24px">
          <Box className={styles['ruleset__text--field']}>
            <TextRegular className={styles['ruleset__text--label']}>{t('fieldBrand')}</TextRegular>
            <TextMedium className={styles['ruleset__text--value']}>{rulesetDetail?.brandName}</TextMedium>
          </Box>

          <Box className={styles['ruleset__text--field']}>
            <TextRegular className={styles['ruleset__text--label']}>{t('livestreamType')}</TextRegular>
            <TextMedium className={styles['ruleset__text--value']}>{rulesetDetail?.type}</TextMedium>
          </Box>
        </Flex>
        <Flex gap="24px">
          <Box className={styles['ruleset__text--field']}>
            <TextRegular className={styles['ruleset__text--label']}>{t('fieldAccount')}</TextRegular>
            <Iteration
              items={rulesetDetail?.accountLivestreams}
              render={(account) => {
                return (
                  <Box key={account?.id} className={styles['ruleset__container--account']}>
                    <TextBold>{account?.name}</TextBold>
                    <TextMedium>{account?.ecommerce}</TextMedium>
                  </Box>
                );
              }}
            />
          </Box>

          <Box className={styles['ruleset__text--field']}>
            <TextRegular className={styles['ruleset__text--label']}>{t('fieldStudio')}</TextRegular>
            <Condition
              statement={rulesetDetail?.type === 'Cross-Platform'}
              fallback={
                <Box className={styles['ruleset__container--account']}>
                  <TextMedium>{rulesetDetail?.accountLivestreams[0]?.studio}</TextMedium>
                </Box>
              }
            >
              <Iteration
                items={rulesetDetail?.accountLivestreams}
                render={(account) => {
                  return (
                    <Box key={account?.id} className={styles['ruleset__container--account']}>
                      <TextMedium>{account?.studio}</TextMedium>
                    </Box>
                  );
                }}
              />
            </Condition>
          </Box>
        </Flex>
        <Flex gap="24px">
          <Box className={styles['ruleset__text--field']}>
            <TextRegular className={styles['ruleset__text--label']}>{t('liveTimePerDay')}</TextRegular>
            <TextMedium className={styles['ruleset__text--value']}>
              {t('timeFormatHours', { hours: rulesetDetail?.liveHours, timeRange: formatTimeRange(rulesetDetail?.normalStart, rulesetDetail?.normalEnd) })}
            </TextMedium>
          </Box>

          <Box className={styles['ruleset__text--field']}>
            <TextRegular className={styles['ruleset__text--label']}>{t('paydayDoubleDateLiveTime')}</TextRegular>
            <TextMedium className={styles['ruleset__text--value']}>
              {t('timeFormatHours', { hours: rulesetDetail?.paydayLiveHours, timeRange: formatTimeRange(rulesetDetail?.paydayStart, rulesetDetail?.paydayEnd) })}
            </TextMedium>
          </Box>
        </Flex>
        <Condition statement={rulesetDetail?.isUseAgency}>
          <Flex gap="24px">
            <Box className={styles['ruleset__text--field']}>
              <TextRegular className={styles['ruleset__text--label']}>{t('agencySchedule')}</TextRegular>
              <TextMedium className={styles['ruleset__text--value']}>
                {t('timeFormatHours', { hours: 0, timeRange: formatTimeRange(rulesetDetail?.agencyNormalStart, rulesetDetail?.agencyNormalEnd) }).replace(/^[^,]+,\s*/, '')}
              </TextMedium>
            </Box>
            <Box className={styles['ruleset__text--field']}>
              <TextRegular className={styles['ruleset__text--label']}>{t('agencyScheduleOnPaydayDoubleDate')}</TextRegular>
              <TextMedium className={styles['ruleset__text--value']}>
                {t('timeFormatHours', { hours: 0, timeRange: formatTimeRange(rulesetDetail?.agencyPaydayStart, rulesetDetail?.agencyPaydayEnd) }).replace(/^[^,]+,\s*/, '')}
              </TextMedium>
            </Box>
          </Flex>
        </Condition>
        <Box className={styles['ruleset__container--change-ruleset']}>
          <TextSemiBold className={styles['ruleset__text--label']}>
            {t('dataIncorrectChangeDesc')} <ButtonChangeRuleset ruleset={rulesetDetail} />
          </TextSemiBold>
        </Box>
      </Box>

      <Box className={styles['ruleset__section--right']}>
        <TextRegular className={styles['ruleset__text--label-host']}>{t('hostLabel')}</TextRegular>
        <Iteration
          items={rulesetDetail?.users || []}
          render={(item, index) => (
            <Box key={index} className={styles['host-item__container']}>
              <TextRegular>{index + 1}.</TextRegular>
              <Flex gap={'4px'}>
                <TextBold>{item.name}</TextBold>
                <Condition statement={item.isPregnancy}>
                  <TextMedium>({t('pregnantLabel')})</TextMedium>
                </Condition>
              </Flex>
            </Box>
          )}
        />
      </Box>
    </Box>
  );
};

export default RulesetDetail;
